import React from 'react';
import PageHeader from './components/PageHeader';
import SettingsRoles from './SettingsRoles';

function RolesPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Roles & Permissions"
        subtitle="Manage user roles and permissions"
        backTo="/settings/users-and-permissions"
        backLabel="Users & Permissions"
        sticky
      />
      <main className="max-w-7xl mx-auto px-6 py-8">
        <SettingsRoles />
      </main>
    </div>
  );
}

export default RolesPage;
